import $ from 'jquery';
import hotkeys from 'hotkeys-js';
import Popup from '../utilities/Popup';

$('.js-popup-show').click(function () {
    const width = $(this).attr('data-popup-width');
    Popup.show($(this).attr('data-popup'), width);
});

$('.popup__overlay, .popup__close').click(function () {
    Popup.hide($(this).parents('.popup').attr('data-popup'));
    $('iframe').each(function () {
        var src = $(this).attr('src');
        $(this).attr('src', src);
    });
});

setInterval(() => {
    let dots = $('.popup__loader').text();
    if (dots.length > 10) {
        dots = '.';
    } else {
        dots = dots + '.';
    }
    $('.popup__loader').text(dots);
}, 500);

hotkeys('esc', () => {
    if (!$('.popup').hasClass('popup--noclose')) {
        Popup.hide();
    }
});
